import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import {
  Page, Card, Layout, SkeletonBodyText, Modal, Button, Pagination, Badge, Toast, ChoiceList, Tabs, Filters,Select,
  Checkbox, Popover, ActionList, ExceptionList, SkeletonPage, EmptyState, Thumbnail, Link, Icon, BlockStack, Box, ButtonGroup, InlineStack
} from "@shopify/polaris";

import {
  DeleteMajor,
  ViewMinor,
  ResourcesMajor,
  // AlertMinor,
  PlayCircleMajor,
  QuestionMarkMajor,
  // QuestionMarkMinor
} from '@shopify/polaris-icons';
import Switch from "react-switch";
import {
  getGetSourcingListCjCount,
  reqGetSourcingListData,
  getPostSourcingCancel,
  reqGetUserSubcribe, reqGoogleAnalytics, getGetSourcingListCjDelete, reqPostUserPrivate
} from '../../../../api';
import utils from '../../../../utils/utils'
import SourcingModal from '../components/SourcingModal';
import SourcingConfirmModal from '../components/SourcingConfirmModal';
import NoviceSourcingModal from '../../../../components/NoviceGuidance/NoviceSourcingModal'
import '../index.css';

import intl from '../../../../i18n/intl'
import { store } from '../../../../store';
// import utils from '../../../../utils/utils';
import UpgradePlanModal from '../../SubscriptionPaid/components/UpgradePlanModal';
import SourcingLimitModal from '../../SubscriptionPaid/components/SourcingLimitModal';
import ShopifyOrder from './ShopifyOrder/Index'
import AppBridge from '../../../../utils/appBridge';
class SourcingClass extends Component {

  state = {
    //页面动作
    loadingPage: true,
    isSearching: '0',
    page: 1,
    size: 20,
    hasPrevious: false,
    hasNext: true,
    ShowCountNumber: 0,
    // 已选中的个数
    checkedCount: 0,
    // 是否全选
    checked: false,
    // 选择数据库所有记录
    selectAllMoreChecked: false,

    // 列表数据
    sourcingData: [],
    // 列表行数据
    SourcingTableTrHtml: <tr></tr>,

    tabSelected: 0,
    summary: { All: 0, Pending: 0, inProcessingCount: 0, Failed: 0, Success: 0 },
    queryValue: '',  // 关键词内容搜索
    filterStatus: [],  // 类型搜索

    EffectiveCount: 0,
    BulkButtonLoading: false,
    BulkOperationTipsActive: false,
    isBulkOperationsRequest: false,
    removeIds: [],
    noviceModal:false,//引导视频

    // 创建sourcing弹窗
    SourcingModalContent: '',
    // 限制sourcing请求次数弹窗
    sourcingLimitModalShow: false,
    // home页面跳转过来
    isfirstFormHomePage: 1,

    // checkChromePlugins: {}, // 接收公共数据中的chorme_plugins id和install_check分别表示谷歌插件ID和安装检查功能是否可用
    CheckGooglePluginActive: false, // 谷歌插件弹窗开关状态
    GooglePluginInstall: false, // 是否安装谷歌插件

    isOpenSourcingConfirmModal: false, // 是否弹出SourcingConfirm弹窗
    sourcingRecord:0,

    sourcingLimit: 0, // 谷歌插件弹窗开关状态
    sourcingDay: 3, // sourcing限制次数
    privateProduct:0,// 产品是否私有化
    upgradeModal:false,//升级付费弹窗
    TabSelectArray:[
      {
        id: "tab-sourcing-all",
        content: intl.get("All"),
        accessibilityLabel: "All sourcing status",
      },
      {
        id: "tab-sourcing-pending",
        content: intl.get('Pending') + '(' + 0 + ')',
        accessibilityLabel: "Pending",
      },
      // {
      //   id: "tab-sourcing-processing",
      //   content: intl.get('In processing') + '(' + 0 + ')',
      //   accessibilityLabel: "In processing",
      // },
//       {
//         id: "tab-awaiting-confirmation",
//         content: <div className='tab-awaiting-confirmation'>
//           {intl.get('Awaiting confirmation') + '(' + (0) + ')'}
//         <Tooltip content={intl.get(`The "Awaiting confirmation" request indicates that we need your confirmation. Please click on the bubble in the request for confirmation. If the product matches, click the "Confirm" button. If it doesn't match, click the "Decline" button, and we will re-match for you.`)}>
//         <Icon
//   source={QuestionMarkMinor}
//   tone="base"
// />
//       </Tooltip></div> ,
//         accessibilityLabel: "Awaiting confirmation",
//       },
      {
        id: "tab-sourcing-failed",
        content: intl.get('Failed') + '(' + 0 + ')',
        accessibilityLabel: "Failed sourcing",
      },
      {
        id: "tab-sourcing-success",
        content: intl.get('Success') + '(' + 0 + ')',
        accessibilityLabel: "Success sourcing",
      },
    ],
    isFirstButtonActive: true,
    filterSearch: 1,
  };

  //进入页面调用接口
  componentDidMount () {
    this.getSourcingList();
    if(AppBridge && AppBridge.exist()) {
      AppBridge.setTitleBar('Sourcing')
      }
  }
  
  // shouldComponentUpdate(nextProps, nextState) {
    // if (!_.isNil(nextProps.chromePlugins)){
    //   if (Boolean(Object.keys(nextProps.chromePlugins).length)) {
    //     if (nextProps.chromePlugins !== this.state.checkChromePlugins) {
    //       this.setState({
    //         checkChromePlugins: nextProps.chromePlugins
    //       }, () => {
    //         if (Boolean(this.state.checkChromePlugins.install_check)) {
    //           this.checkGooglePlugin(this.state.checkChromePlugins.id);
    //         }
    //       })
    //     }
    //   }
    //   return true
    // }
    
    
  //   console.log(nextState,nextProps,this.state.TabSelectArray,window.language);
  //   return false
  // }
  componentDidUpdate(prevProps,prevState){
    if (prevState.TabSelectArray === this.state.TabSelectArray) {
      this.updatePageDetail();
      this.setState({
        TabSelectArray:[
          {
            id: "tab-sourcing-all",
            content: intl.get("All"),
            accessibilityLabel: "All sourcing status",
          },
          {
            id: "tab-sourcing-pending",
            content: intl.get('Pending') + '(' + this.state.summary.Pending + ')',
            accessibilityLabel: "Pending",
          },
          // {
          //   id: "tab-sourcing-processing",
          //   content: intl.get('In processing') + '(' + this.state.summary.inProcessingCount + ')',
          //   accessibilityLabel: "In processing",
          // },
          // {
          //   id: "tab-awaiting-confirmation",
          //   content: <div className='tab-awaiting-confirmation'>
          //     {intl.get('Awaiting confirmation') + '(' + (this.state.summary.awaitingCount || 0) + ')'}
          //   <Tooltip content={intl.get(`The "Awaiting confirmation" request indicates that we need your confirmation. Please click on the bubble in the request for confirmation. If the product matches, click the "Confirm" button. If it doesn't match, click the "Decline" button, and we will re-match for you.`)}>
          //   <Icon
          //     source={QuestionMarkMinor}
          //     tone="base"
          //   />
          // </Tooltip></div>,
          //   accessibilityLabel: "Awaiting confirmation",
          // },
          {
            id: "tab-sourcing-failed",
            content: intl.get('Failed') + '(' + this.state.summary.Failed + ')',
            accessibilityLabel: "Failed sourcing",
          },
          {
            id: "tab-sourcing-success",
            content: intl.get('Success') + '(' + this.state.summary.Success + ')',
            accessibilityLabel: "Success sourcing",
          },
        ]
      })
    }
  }

  // 创建sourcing请求成功，刷新一下列表页面
  requestCreateSuccessCallBack = () => {
    this.getSourcingList(true);
  }

  toggleToast = (showToastText, showToastIserror = false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };

  // 获取列表数据
  getSourcingList = async (isSearch = false) => {
    const { search } = this.props.location
    let url = new URLSearchParams(search);
    let dsm_num = url.get("num");
    let from = url.get("from");
    const isfirstFormHomePage = this.state.isfirstFormHomePage === 1 && dsm_num
    if (isfirstFormHomePage) {
      isfirstFormHomePage && this.setState({
        tabSelected: Number(dsm_num),
        isfirstFormHomePage: 2,
      },()=>{
        this.props.history.replace('/admin/sourcing')
      })
    }
    if (isSearch) {
      this.setState({
        isSearching: '1',
        hasPrevious: false,
        hasNext: false,
      });
    } else {
      this.setState({
        loadingPage: true,
        hasPrevious: false,
        hasNext: false,
      });
    }
    let params = {
      q: this.state.queryValue,
      page: this.state.page,
      size: this.state.size,
      search_from:this.state.filterSearch,
      sourcing_status: this.state.filterStatus.length > 0 ? this.state.filterStatus[0] : 'All',
      platform:1,
    };

    if (!isSearch && !_.isNil(isfirstFormHomePage)) {
      if(from) {
        // 从首页Statistics跳转过来的
        this.setState({
          filterStatus: from
        }, () => {
          params.sourcing_status = this.state.filterStatus[0]
        })
      } else {
        this.setState({
          filterStatus: ['Awaiting confirmation']
        }, () => {
          params.sourcing_status = this.state.filterStatus[0]
        })
      }
    }

    params = isfirstFormHomePage ? Object.assign(params, { sourcing_status: from }) : params

    // params = isfirstFormHomePage ? Object.assign(params, { sourcingStatus: JSON.stringify(state.type) }) : params

    const response = await reqGetSourcingListData(params);
    const countList = await getGetSourcingListCjCount({platform:1})
    if (response.code === '200') {
      let res = await reqGetUserSubcribe()
      let getData = response.data;
      let countLists = countList.data;
     let list = getData.list.map((item, index) => {
        item.checked = 0;
        item.failed_active = 0
        return item;
      });
      this.setState({
        loadingPage: false,
        sourcingData:list,
        summary: countLists.summary,
        total: getData.count,
        ShowCountNumber: getData.count,
        isSearching: '0',
        sourcingLimit: Object.values(res?.data?.limit).length > 0 ?  res?.data?.limit?.sourcing + res?.data?.limit?.sourcing_job : 0,
        sourcingDay: res?.data?.day?.sourcing_num,
        privateProduct:countLists.auto_sourcing
      }, () => {
        // 更新列表数据
        this.updatePageDetail();
        this.setState({
          TabSelectArray:[
            {
              id: "tab-sourcing-all",
              content: intl.get("All"),
              accessibilityLabel: "All sourcing status",
            },
            {
              id: "tab-sourcing-pending",
              content: intl.get('Pending') + '(' + countLists.summary.Pending + ')',
              accessibilityLabel: "Pending",
            },
            // {
            //   id: "tab-sourcing-processing",
            //   content: intl.get('In processing') + '(' + countLists.summary.inProcessingCount + ')',
            //   accessibilityLabel: "In processing",
            // },
            // {
            //   id: "tab-awaiting-confirmation",
            //   content: <div className='tab-awaiting-confirmation'>
            //     {intl.get('Awaiting confirmation') + '(' + (countLists.summary.awaitingCount || 0) + ')'}
            //   <Tooltip content={intl.get(`The "Awaiting confirmation" request indicates that we need your confirmation. Please click on the bubble in the request for confirmation. If the product matches, click the "Confirm" button. If it doesn't match, click the "Decline" button, and we will re-match for you.`)}>
            //   <Icon
            //     source={QuestionMarkMinor}
            //     tone="base"
            //   />
            // </Tooltip></div>,
            //   accessibilityLabel: "Awaiting confirmation",
            // },
            {
              id: "tab-sourcing-failed",
              content: intl.get('Failed') + '(' + countLists.summary.Failed + ')',
              accessibilityLabel: "Failed sourcing",
            },
            {
              id: "tab-sourcing-success",
              content: intl.get('Success') + '(' + countLists.summary.Success + ')',
              accessibilityLabel: "Success sourcing",
            },
          ]
        })
      });

      // 更新分页数据
      if (this.state.page > 1) {
        this.setState({
          hasPrevious: true
        });
      } else {
        this.setState({
          hasPrevious: false
        });
      }

      const maxPage = Math.ceil(response.count / this.state.size);
      if (this.state.page < maxPage) {
        this.setState({
          hasNext: true
        });
      } else {
        this.setState({
          hasNext: false
        });
      }

    } else {
      this.toggleToast(response.msg);
      this.setState({
        loadingPage: false,
        sourcingData: [],
        isSearching: '0',
      });
    }

  }

  

  // 打开SourcingConfirm 弹窗
  openSourcingConfirm(record) {
    this.setState({
      isOpenSourcingConfirmModal: true,
      sourcingRecord: record
    })
  }

  closeConfirmModal(){
    this.setState({
      isOpenSourcingConfirmModal: false
    },()=>{
      if (this.state.sourcingRecord !== 0) {
        this.cancelSourcing()
      }
    })
  }
  // 取消sourcing状态
  cancelSourcing = async()=> {
    try {
      let res = await getPostSourcingCancel({sourcing_id:this.state.sourcingRecord})
    if (res.code === '200') {
      this.toggleToast('Declined successfully')
      this.getSourcingList(true)
    }else {
      this.toggleToast(res.msg)
    }
    } catch (error) {
      
    }
    
  }
// 时间转换
getYMDStart = (timeStamp) => {
  if (timeStamp !== 0 || timeStamp !== '') {
    
  
  var time = new Date(timeStamp *1000);
  var y=time.getFullYear();//返回年份
  //getMonth方法从 Date 对象返回月份 (0 ~ 11)，返回结果需要手动加一var d = time.getDate();
  // getDate方法从 Date 对象返回一个月中的某一天 (1 ~ 31)
  var M=time.getMonth()+1;
  var d=time.getDate();
  var h=time.getHours();
  var m = time.getMinutes(); 
  if (M <= 9) {
    M = '0' + M
  }
  if (d <= 9) {
    d = '0' + d
  }
  if (h <= 9) {
    h = '0' + h
  }
  if (m <= 9) {
    m = '0' + m
  }
  
  var times = y + '-' + M + '-' + d + ' ' + h + ':' + m
//得到这种格式2023-5-11 15:32:29
  return times;
}else {
  return ''
}
};
  // 更新列表信息
  updatePageDetail () {
    let data = this.state.sourcingData;
    let isCheckedAll = false;
    let checkedCount = 0;
    let sourcingTableTrHtmlContent = <tr></tr>;

    if (data.length > 0) {

      sourcingTableTrHtmlContent = data.map((item, key) => {
        let trHtml = '';
        if (item.checked === 1) {
          checkedCount++;
        }

        let sourcingStatus = '';
        let failedClass = '';
        if (this.state.tabSelected === 3 && this.state.filterStatus[0] === 'Awaiting confirmation'){
          sourcingStatus = (
            <div className='awaiting_status' onClick={() => this.openSourcingConfirm(item.id)}>
              <Badge tone="attention">{intl.get("Awaiting confirmation")}</Badge>
              <div className='awaiting_mark'>
                <img src='/awaiting_news.png' alt='awaiting_news' />
              </div>
            </div>
          )
        }else{
        
          if (Number(item.is_new) === 1) {
            switch (item.status) {
              case 0:
                sourcingStatus = <Badge>{intl.get("Pending")}</Badge>;
                break;
              case 1:
                sourcingStatus = (
                  <Popover
                    active={(item.failed_active === 1) ? true : false}
                    preferredAlignment="left"
                    activator={
                      <div className="">
                        <Button
                          variant='plain'
                          disclosure={(item.failed === 1) ? true : false}
                          onClick={this.showFailedReasonActive.bind(this, key)}
                        >
                          <Badge tone="success">{intl.get("Success")}</Badge>
                        </Button>
                      </div>
                    }
                    onClose={this.showFailedReasonActive.bind(this, key)}
                  >
                    <Card sectioned>
                      <p style={{ maxWidth: '200px' }}>
                        {intl.get('Please check the product in List Products.')}
                      </p>
                    </Card>
                  </Popover>
                );
                break;
              case 2:
                sourcingStatus = (
                  <Popover
                    active={(item.failed_active === 1) ? true : false}
                    preferredAlignment="left"
                    activator={
                      <div className="">
                        <Button
                          variant='plain'
                          disclosure={true}
                          onClick={this.showFailedReasonActive.bind(this, key)}
                        >
                          <Badge tone="critical">{intl.get("Failed")}</Badge>
                        </Button>
                      </div>
                    }
                    onClose={this.showFailedReasonActive.bind(this, key)}
                  >
                    <Card sectioned>
                      <p style={{ maxWidth: '200px',wordBreak: 'break-all' }}>
                        {item.fail_reason}
                      </p>
                    </Card>
                  </Popover>
                );
  
                failedClass = 'Failed';
                break;
              // case 3:
              //   sourcingStatus = <Badge tone="info">{intl.get("In progressing")}</Badge>;
              //   break;
              // case 7 :

              //   sourcingStatus = <div className='awaiting_status' onClick={() => this.openSourcingConfirm(item.record)}>
              //     <Badge tone="attention">{intl.get("Awaiting confirmation")}</Badge>
              //     <div className='awaiting_mark'>
              //       <img src='/awaiting_news.png' alt='awaiting_news' />
              //     </div>
              //   </div>
              //   break;
              default:
                sourcingStatus = <Badge>{intl.get("Pending")}</Badge>;
            }
          }else{
          switch (item.status) {
            case 99:
              sourcingStatus = (
                <Popover
                  active={(item.failed_active === 1) ? true : false}
                  preferredAlignment="left"
                  activator={
                    <div className="">
                      <Button
                        variant='plain'
                        disclosure={(item.failed === 1) ? true : false}
                        onClick={this.showFailedReasonActive.bind(this, key)}
                      >
                        <Badge tone="success">{intl.get("Success")}</Badge>
                      </Button>
                    </div>
                  }
                  onClose={this.showFailedReasonActive.bind(this, key)}
                >
                  <Card sectioned>
                    <p style={{ maxWidth: '200px' }}>
                      {intl.get('Please check the product in List Products.')}
                    </p>
                  </Card>
                </Popover>
              );
              break;
            case 1:
              sourcingStatus = <Badge>{intl.get("Pending")}</Badge>;
              break;
            case 2:
            sourcingStatus = <Badge>{intl.get("Pending")}</Badge>;
            break;
            case 4:
            sourcingStatus = <Badge>{intl.get("Pending")}</Badge>;
            break;
            // case 3:
            //   sourcingStatus = <Badge tone="info">{intl.get("In progressing")}</Badge>;
            //   break;
            case 3:
              sourcingStatus = (
                <Popover
                  active={(item.failed_active === 1) ? true : false}
                  preferredAlignment="left"
                  activator={
                    <div className="">
                      <Button
                        variant='plain'
                        disclosure={(item.failed === 1) ? true : false}
                        onClick={this.showFailedReasonActive.bind(this, key)}
                      >
                        <Badge tone="critical">{intl.get("Failed")}</Badge>
                      </Button>
                    </div>
                  }
                  onClose={this.showFailedReasonActive.bind(this, key)}
                >
                  <Card sectioned>
                    <p style={{ maxWidth: '200px',wordBreak: 'break-all' }}>
                      {item.fail_reason}
                    </p>
                  </Card>
                </Popover>
              );

              failedClass = 'Failed';
              break;
            // case 7 :
            //   sourcingStatus = <div className='awaiting_status' onClick={() => this.openSourcingConfirm(item.record)}>
            //     <Badge tone="attention">{intl.get("Awaiting confirmation")}</Badge>
            //     <div className='awaiting_mark'>
            //       <img src='/awaiting_news.png' alt='awaiting_news' />
            //     </div>
            //   </div>
            //   break;
            default:
              sourcingStatus = <Badge>{intl.get("Pending")}</Badge>;
          }
        }
        }
        trHtml = (
          <tr
            key={key}
            onMouseOver={(item.status === 1 || item.status === 4) ? () => this.handleOnMouseOver(true, key) : () => { }}
            onMouseLeave={(item.status === 1 || item.status === 4) ? () => this.handleOnMouseOver(false, key) : () => { }}
          >
            <td>
              <Checkbox
                label=''
                labelHidden
                checked={item.checked}
                onChange={this.handleSingleCheckboxChange.bind(this, key)}
              />
            </td>
            <td className="Ticket_ID">
              {item.show_id}
            </td>
            <td>
              <div className='Ticket_Image'>
                {item.all_images && (
                  <Thumbnail
                    source={item.all_images}
                    alt="Dropshipman"
                    size='small'
                  />
                )}
              </div>
            </td>
            <td className="Ticket_Product_Title">
                <span title={item.title}>
                  {item.title}
                </span>
            </td>
            <td className="Ticket_Time" title={item.date_title}>
              {this.getYMDStart(item.created_at)}
            </td>
            {/* <td className="Ticket_Purchase_Type">
              {item.purchase_type}
            </td> */}
            <td className="Ticket_Type">
              {(item.request_type === 1) ? intl.get('Exist') : intl.get('Explore')}
            </td>
            <td className={"Ticket_Status " + failedClass}>
              {sourcingStatus}
            </td>
            {/* price */}
            {/* <td className="Ticket_Price">
              <p>
                {
                  item.price !== 0 ? intl.get('Cost：US') + '$' + item.cost : '-'
                }
              </p>
              <p style={{ color: 'gray' }}>
                {
                  item.price !== 0 ? intl.get('Price：US') + '$' + item.price : '-'
                }
              </p>
            </td> */}
            <td className="Ticket_Actions">
              <div className="Sourcing_Action Button">
                <Button
                  icon={ResourcesMajor}
                  variant='plain'
                  onClick={() => this.openIntercom(item.show_id)}
                >
                  {intl.get("Contact us")}
                </Button>
              </div>

              <div className="Sourcing_Action">
                <Popover
                  active={(item.moreAction === 1) ? true : false}
                  activator={
                    <div className="Prodcut_More_Action">
                      <Button
                        disclosure
                        onClick={this.togglePopoverActive.bind(this, key)}
                      >
                        {intl.get("More Actions")}
                      </Button>
                    </div>
                  }
                  onClose={this.togglePopoverActive.bind(this, key)}
                >
                  <ActionList
                    items={[
                      {
                        content:
                          <ExceptionList
                            items={[
                              {
                                icon: ViewMinor,
                                description: intl.get('View details'),
                              },
                            ]}
                          />,
                        onAction: () => this.handleSourcingModal(item.id, true,item.is_new)
                      },
                      {
                        content:
                          <ExceptionList
                            items={[
                              {
                                icon: DeleteMajor,
                                description: intl.get('Delete'),
                              },
                            ]}
                          />,
                        onAction: () => this.handleBulkOperationModal('single', item.id,item.is_new),
                        disabled: false
                      }
                    ]}
                  />
                </Popover>
              </div>
            </td>
          </tr>
        );

        return (
          trHtml
        );
      });
    }

    // 判断是否全选
    if (data.length === checkedCount && checkedCount !== 0) {
      isCheckedAll = true;
    }

    this.setState({
      SourcingTableTrHtml: sourcingTableTrHtmlContent,
      ShowCountNumber: data.length,
      checked: isCheckedAll,
      checkedCount: checkedCount,
    });
  }
  // 搜索输入
  handleChangeSearch = utils.debounce(()=>{
    this.getSourcingList(true);
  },500)
  // 全选 CheckBox  change
  handleAllCheckboxChange = (value) => {
    let _data = this.state.sourcingData;
    let setCheckedValue = value ? 1 : 0;

    for (let i = 0; i < _data.length; i++) {
      _data[i].checked = setCheckedValue;
    }

    if (!value && this.state.selectAllMoreChecked) {
      this.setState({
        selectAllMoreChecked: false
      });
    }

    this.setState({
      checked: value,
      sourcingData: _data
    }, () => {
      this.updatePageDetail();
    });
  }

  // checkbox 单选
  handleSingleCheckboxChange = (RecordKey, value) => {
    let _data = this.state.sourcingData;
    _data[RecordKey].checked = (value === true) ? 1 : 0;

    if (!value && this.state.selectAllMoreChecked) {
      this.setState({
        selectAllMoreChecked: false
      });
    }

    this.setState({
      sourcingData: _data
    }, () => {
      this.updatePageDetail();
    });
  }

  // 选择所有sourcing数据（该用户所有数据，含未展示的）
  handleSelectAllMoreChecked = (isChecked) => {
    this.setState({
      selectAllMoreChecked: isChecked
    });
  }

  // tabs 切换
  handleTabChange = (index) => {
    let selectStatus = [];
    switch (index) {
      case 1:
        selectStatus = ["Pending"];
        break;
      // case 2:
      //   selectStatus = ["In processing"];
      //   break;
      // case 2:
      //   selectStatus = ["Awaiting confirmation"];
      //   break;
      case 2:
        selectStatus = ["Failed"];
        break;
      case 3:
        selectStatus = ["Success"];
        break;
      default:
    }

    this.setState({
      tabSelected: index,
      page: 1,
      filterStatus: selectStatus,
      filterSearch:1
    }, () => {
      this.handleChangeSearch()
    });
  }

  // filter 产品状态选项选择
  handleFilterStatusChange = (status) => {
    this.setState({
      filterStatus: status,
      page: 1,
    }, () => {
      this.handleChangeSearch()
    });
  }

  // filter 产品状态选项移除
  handleFilterStatusRemove = () => {
    this.setState({
      filterStatus: ['All'],
      page: 1,
      tabSelected:0
    }, () => {
      this.handleChangeSearch()
    });
  }

  // filter 清除所有选项选择
  handleFiltersClearAll = () => {
    this.setState({
      queryValue: '',
      filterStatus: ['All'],
      page: 1,
    }, () => {
      this.handleChangeSearch()
    });
  }

  
  handleFiltersQueryChange = (value) => {
    this.setState({
      queryValue: value,
      page: 1,
    }, () => {
      this.handleChangeSearch()
      // 
  })
  }
  handleFiltersQueryChanges = (value) => {
    this.setState({
      filterSearch:Number(value)
    })
  }
  handleChangeSearchRemove = utils.debounce(()=>{
    this.getSourcingList(true);
  },200)
  // 清空搜索内容
  handleQueryValueRemove = () => {
    this.setState({
      queryValue: '',
      page: 1,
    }, () => {
      this.handleChangeSearchRemove()
    });
  }

  // More Actions 展开
  togglePopoverActive = (recordKey) => {
    let data = this.state.sourcingData;
    let old = data[recordKey].moreAction;
    data[recordKey].moreAction = old ? 0 : 1;
    this.setState({
      sourcingData: data
    }, () => {
      this.updatePageDetail();
    });
  }

  // 按钮鼠标经过展示下拉图标
  handleOnMouseOver = (bool, recordKey) => {
    let data = this.state.sourcingData;
    data[recordKey].failed = bool ? 1 : 0;

    this.setState({
      sourcingData: data
    }, () => {
      this.updatePageDetail();
    });
  }

  // 查看请求失败原因
  showFailedReasonActive = (recordKey) => {
    let data = this.state.sourcingData;
    let old = data[recordKey].failed_active;
    data[recordKey].failed_active = old ? 0 : 1;

    this.setState({
      sourcingData: data
    }, () => {
      this.updatePageDetail();
    });
  }

  // 打开sourcing弹窗，详情弹窗
  handleSourcingModal = (id = 0, isDetail = false,is_new = 0) => {
    //Sourcing页面sourcing按钮点击gtag
    reqGoogleAnalytics('click', 'sourcing_sourcing_click');
    // 查看sourcing详情
    if (id === 0 && this.state.sourcingLimit >= this.state.sourcingDay) {
      // sourcing请求限制提示
      this.handleSourcingLimitModal();
      return;
    }

    let modalContent = (
      <SourcingModal
        show={true}
        updateCallBackFun={this.requestCreateSuccessCallBack}
        id={id}
        type={1}
        is_new={is_new}
        isDetail={isDetail}
      />
    )
    this.setState({
      SourcingModalContent: modalContent
    });
  }
  // 私有化开关
  sourcingPrivate = async (value)=>{
    let res = await reqPostUserPrivate({checked:value})
    if (res.code === '200') {
      this.toggleToast('Set up successfully')
    }else {
      this.toggleToast(res.msg)
    }
  }
  handleToggleSwitch = (newValue) =>{
    
    let person = store.getState().languageReducer.subScriptData;
    switch (newValue) {
      case true:
        if (person?.level >=1 && person?.level <= 3) {
          this.setState({
            privateProduct:1
          },()=>{
            this.sourcingPrivate(1)
          })
        }else{
          this.setState({upgradeModal:true})
        }
        break;
      case false:
        if (person?.level >=1 && person?.level <= 3) {
          this.setState({
            privateProduct:0
          },()=>{
            this.sourcingPrivate(0)
          })
        }else{
          this.setState({upgradeModal:true})
        }
        break;
      default:
        break;
    }
  }

  // sourcing请求弹窗控制开关
  handleSourcingLimitModal = () => {
    this.setState(({ sourcingLimitModalShow }) => ({
      sourcingLimitModalShow: !sourcingLimitModalShow
    }))
  }

  // [单个/批量] 请求记录移除 弹窗
  handleBulkOperationModal = (type, id = 0,is_new) => {
    let _message = '';
    let _more = this.state.selectAllMoreChecked ? '+' : '';
    let EffectiveCount = 0;
    let ids = [];
    // let list = []
    // 统计操作类型的数量
    if (type === 'bulk') {
      let data = this.state.sourcingData;
      for (let i = 0; i < data.length; i++) {
        if (data[i].checked === 1) {
          EffectiveCount++;
          ids.push(data[i].id)
        }
      }
    } else if (type === 'single') {
      EffectiveCount = 1;
      ids.push(id)
    }
    if (EffectiveCount < 2) {
      _message = intl.get("{{EffectiveCount}} record will be deleted.",EffectiveCount);
    } else {
      _message =  intl.get("{{EffectiveCount}} record will be deleted.",(EffectiveCount+_more));
    }

    this.setState({
      BulkOperationTipMessage: _message,
      EffectiveCount: EffectiveCount,
      removeIds: ids,
    }, () => {
      this.setState(({ BulkOperationTipsActive }) => ({ BulkOperationTipsActive: !BulkOperationTipsActive }));
    });
    if (type === 'closed') {
      this.setState({
        BulkButtonLoading:false
      })
    }
  }

  // [批量] 移除记录确认
  handleBulkOperationDone = async () => {
    this.setState({
      BulkButtonLoading: true,
      isBulkOperationsRequest: true,
    });

    // 设置请求参数
    let params = {
       platform:1,
       ids:this.state.removeIds
      // type: 'del',
      // all: this.state.selectAllMoreChecked ? 1 : 0,  // 1 页面记录批量操作 2：用户所有该类型的数据批量操作
    };
    // let listData = this.state.removeIds
    // const formData = new FormData()

    // for (const key in params) {
    //   formData.append(key,params[key])
    // }
    // console.log(listData);
    // listData.forEach((item,ind)=>{
    //   for (const key in item) {
    //     console.log(`ids[${ind}][${key}]`,item[key]);
    //     formData.append(`ids[${ind}]`,item[key])
    //   }
    // })
    const response = await getGetSourcingListCjDelete(params);
    this.setState({
      BulkButtonLoading: false,
      isBulkOperationsRequest: false
    });

    if (response.code === "200") {
      this.toggleToast('Deleted successfully', false);
      this.handleBulkOperationModal('closed');
      // 重新获取数据
      this.getSourcingList(true);

    } else {
      this.handleBulkOperationModal('closed');
      this.toggleToast(response.msg);
    }
  }

  // 打开聊天对话框
  openIntercom = (name = '') => {
    let sendPreMsg = "Hi, I've got a question about sourcing request " + name;
    if (name === '') {
      sendPreMsg = 'Hello, I would like to get more sourcing times. Can you help me?';
    }
    try {
      // 填充信息并激活对话弹窗
      // window.Intercom('showNewMessage', sendPreMsg);
      window.Willdesk.show();
      window.Willdesk.chat(sendPreMsg);
    } catch (error) {
      console.info(error);
    }
    // if (name === '') {
    //   this.handleSourcingLimitModal();
    // }
  }

  // 检测谷歌插件
  checkGooglePlugin = (id) => {
    var image = document.createElement('img');
    let _this = this
    // 必须要启用该插件才可用
    image.src = `chrome-extension://${id}/logo128.png`;
    image.onload = function () {
      _this.setState({
        GooglePluginInstall: true
      })
    };
    image.onerror = function () {
      _this.setState({
        GooglePluginInstall: false
      })
    };
  }

  // 切换谷歌插件弹窗开关
  handleCheckGooglePluginModal = () => {
    this.setState(({ CheckGooglePluginActive }) => ({ CheckGooglePluginActive: !CheckGooglePluginActive }));
  }

  // 跳转Url
  jumpUrl = (url) => {
    window.open(url)
    this.handleCheckGooglePluginModal()
  }

  // 修改状态
  handleStatusEdit = ()=>{
    let list = this.state.sourcingData
    for (let i = 0; i < list.length; i++) {
      if (list[i].record === this.state.sourcingRecord) {
        list[i].status = 1
      }
    }
    this.setState({
      sourcingData:list
    })
  }
  // 切换列表
  handleFirstButtonClick = () => {
    this.setState({
      isFirstButtonActive: true
    })
  }

  handleSecondButtonClick  = () => {
    this.setState({
      isFirstButtonActive: false
    })
  }
  render () {
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} onDismiss={() => this.toggleToast('')} error={this.state.showToastIserror} duration={1500} /> : null;
    const {
      isSearching, ShowCountNumber, isBulkOperationsRequest, checkedCount, SourcingTableTrHtml, SourcingModalContent, sourcingLimitModalShow, EffectiveCount, BulkOperationTipsActive, BulkButtonLoading,
      BulkOperationTipMessage, CheckGooglePluginActive, GooglePluginInstall,sourcingLimit, sourcingDay,privateProduct,TabSelectArray,filterSearch
    } = this.state;
    
    const initSkeletonPage = <div>
     <SkeletonPage fullWidth={true}>
     <Layout>
          <Layout.Section>
          <Card>
          <BlockStack gap={400}>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          </BlockStack>
          </Card>
        </Layout.Section>
          </Layout>
        </SkeletonPage>
    </div>

    const BulkOperationTipsModal = (
      <Modal
        open={BulkOperationTipsActive}
        onClose={() => this.handleBulkOperationModal('closed')}
        title={intl.get('Delete sourcing request')}
        primaryAction={{
          content: intl.get("Done"),
          onAction: this.handleBulkOperationDone,
          disabled: (EffectiveCount > 0) ? false : true,
          loading: BulkButtonLoading
        }}
        secondaryActions={[{
          content: intl.get("Cancel"),
          onAction: () => this.handleBulkOperationModal('closed')
        }]}
      >
        <Modal.Section>
           
            <p style={{ whiteSpace: 'pre-wrap' }}>
              {BulkOperationTipMessage}
            </p>
           
        </Modal.Section>
      </Modal>)

    const EmptyProductList = (ShowCountNumber === 0) ? (
      <div className="emptyWithImg">
        <EmptyState
          // heading={intl.get("Your sourcing list is empty. Go exploring products at Sourcing Square")}
          image="/empty.svg"
        >
          <div style={{ width: '430px' }}>
           {intl.get("Your sourcing list is empty.")}
            {/* <Button plain onClick={this.CallBackToPath}>
              Sourcing Square
            </Button> */}
          </div>
          {/* <p>Your sourcing list is empty. Go exploring products at Sourcing Square</p> */}
          <p style={{ fontSize: '14px', opacity: '0', marginBottom: '0' }}>{intl.get("The sourcing request is shown here, make a request now")}</p>
        </EmptyState>
      </div>
    ) : '';

    // const TabSelectArray = [
    //   {
    //     id: "tab-sourcing-all",
    //     content: intl.get("All"),
    //     accessibilityLabel: "All sourcing status",
    //   },
    //   {
    //     id: "tab-sourcing-pending",
    //     content: intl.get('Pending') + '(' + summary.Pending + ')',
    //     accessibilityLabel: "Pending",
    //   },
    //   {
    //     id: "tab-sourcing-processing",
    //     content: intl.get('In processing') + '(' + summary.inProcessingCount + ')',
    //     accessibilityLabel: "In processing",
    //   },
    //   {
    //     id: "tab-awaiting-confirmation",
    //     content: intl.get('Awaiting confirmation') + '(' + (summary.awaitingCount || 0) + ')',
    //     accessibilityLabel: "Awaiting confirmation",
    //   },
    //   {
    //     id: "tab-sourcing-failed",
    //     content: intl.get('Failed') + '(' + summary.Failed + ')',
    //     accessibilityLabel: "Failed sourcing",
    //   },
    //   {
    //     id: "tab-sourcing-success",
    //     content: intl.get('Success') + '(' + summary.Success + ')',
    //     accessibilityLabel: "Success sourcing",
    //   },
    // ];

    const filters = [
      {
        key: 'filterStatus',
        label: intl.get('Sourcing status'),
        filter: (
          <ChoiceList
            title='Sourcing status'
            titleHidden
            choices={[
              { label: intl.get('Pending'), value: 'Pending' }, 
              // { label: intl.get('In processing'), value: 'In processing' },
              // { label: intl.get('Awaiting confirmation'), value: 'Awaiting confirmation' },
              { label: intl.get('Success'), value: 'Success' },
              { label: intl.get('Failed'), value: 'Failed' },
            ]}
            selected={this.state.filterStatus || []}
            onChange={this.handleFilterStatusChange}
          />
        ),
        shortcut: true,
        hideClearButton: false,
      },
    ];

    const appliedFilters = [];
    if (!isEmpty(this.state.filterStatus)) {
      const key = 'filterStatus';
      appliedFilters.push({
        key,
        label: disambiguateLabel(key, this.state.filterStatus),
        onRemove: this.handleFilterStatusRemove,
      });
    }

    let headings = '';

    //判断是否有批量选择
    if (ShowCountNumber !== 0) {
      if (checkedCount !== 0) {

        // 全选本页面数据，如果数据库总量大于本页面显示数量，显示可选这全部数据
        let selectAllDataButton = <div></div>;

        if (this.state.checked) {
          if (this.state.total > checkedCount) {

            if (this.state.selectAllMoreChecked) {
              selectAllDataButton = (
                <div className="Select_More">
                  <Button onClick={this.handleSelectAllMoreChecked.bind(this, false)} variant='plain' textAlign="left" >
                    {intl.get("All sourcing requests selected. Undo")}
                  </Button>
                </div>
              );

            } else {
              selectAllDataButton = (
                <div className="Select_More">
                  <Button onClick={this.handleSelectAllMoreChecked.bind(this, true)} variant='plain' textAlign="left" >
                    {intl.get('Select all {{size}} sourcing requests',this.state.size)}
                  </Button>
                </div>
              );
            }
          }
        }

        headings = (
          <div className="headings_div__1 notifications">
            <div className="headings_div__2">
              <div className="Polaris-ButtonGroup Polaris-ButtonGroup--segmented" data-buttongroup-segmented="true">

                <div className="Polaris-ButtonGroup__Item">
                  <div className="Polaris-CheckableButton Polaris-CheckableButton__CheckableButton--selectMode Polaris-CheckableButton__CheckableButton--selected">
                    <div className="headings_div__3">
                      <Checkbox
                        label=''
                        labelHidden
                        checked={this.state.checked ? true : 'indeterminate'}
                        onChange={this.handleAllCheckboxChange}
                      />
                    </div>
                    <span className="Polaris-CheckableButton__Label" onClick={this.handleAllCheckboxChange}>
                      {this.state.selectAllMoreChecked ? checkedCount + '+ ' + intl.get("selected") : checkedCount + ' ' + intl.get("selected")}
                    </span>
                  </div>
                </div>

                <div className="Polaris-ButtonGroup__Item">
                  <div>
                    <Button
                      variant='primary'
                      onClick={() => this.handleBulkOperationModal('bulk')}
                      disabled={isBulkOperationsRequest}
                    >
                      {intl.get('Delete')}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            {selectAllDataButton}
          </div>
        )
      }
    }

    // 表头的显示
    const tableTheadTrContent = (headings !== '') ? (
      <tr>
        <th colSpan="7" style={{ textAlign: 'left', padding: '13px 0px 12px 17px' }}>
          {headings}
        </th>
      </tr>
    ) : (
      <tr>
        <th style={{ textAlign: 'left', padding: '20px 0px 20px 16px' }}>
          <Checkbox
            label={intl.get('All')}
            labelHidden
            checked={false}
            onChange={this.handleAllCheckboxChange}
          />
        </th>
        <th>{intl.get('ID')}</th>
        <th></th>
        <th>{intl.get('Title')}</th>
        <th>{intl.get('Date')}</th>
        <th>{intl.get('Type')}</th>
        <th>{intl.get('Status')}</th>
        {/* <th>{intl.get('Price')}</th> */}
        <th>{intl.get('Actions')}</th>
      </tr>
    );

    const SourcingListTable = (ShowCountNumber > 0) ? (
      <section className="Sourcing_Table">
          <table style={{ width: '100%' }}>
            <thead>
              {tableTheadTrContent}
            </thead>
            <tbody>
              {/* tr Html */}
              {SourcingTableTrHtml}
            </tbody>
          </table>
      </section>
    ) : '';

    var footerContentMsg = '';
    if (this.state.total > 0) {
      const startNum = (((this.state.page - 1) * this.state.size) + 1);
      const endNum = (this.state.page * this.state.size > this.state.total) ? this.state.total : this.state.page * this.state.size;
      // footerContentMsg = <div className="Pagination_Result__Footer">{"Showing " + startNum + " - "+ endNum + " of " + this.state.total + " results"}</div>;
      footerContentMsg = <div>{intl.get("Showing {{startNum}} - {{endNum}} of {{total}} results", startNum, endNum, this.state.total)}</div>;
    }

    const PaginationSettings = this.state.loadingPage ? '' :
      (ShowCountNumber !== 0) ?
        <div className="Polaris-New-Pagination">
          <Pagination
            label={footerContentMsg}
            hasPrevious={this.state.hasPrevious}
            onPrevious={() => {
              this.setState(({ page: this.state.page - 1 }), () => {
                this.getSourcingList(true);
              });
            }}
            hasNext={this.state.hasNext}
            onNext={() => {
              this.setState(({ page: this.state.page + 1 }), () => {
                this.getSourcingList(true);
              });
            }}
          />
        </div> : '';
    const pageContent = this.state.loadingPage ? initSkeletonPage : (
      <section className='Dropshipman_Sourcing'>
        <Page
          fullWidth
        >
          <Box>
        <div className='sourcing_page_head'>
        <ButtonGroup variant="segmented">
          <Button pressed={this.state.isFirstButtonActive} onClick={()=>this.handleFirstButtonClick()}>
           {intl.get("My Quote")}
          </Button>
          <Button pressed={!this.state.isFirstButtonActive} onClick={()=>this.handleSecondButtonClick()}>
          {intl.get("Shopify Order")}
          </Button>
        </ButtonGroup>
         { this.state.isFirstButtonActive && <div className='sourcing_page_head_title novice_content'>
          <div className="auto_Fulfillment sourcing_page_head_button">
            <Box style={{marginRight:'10px'}}>
            <Button onClick={()=>this.setState({noviceModal:true})}>
              <InlineStack blockAlign='center'>
              <Icon
              source={PlayCircleMajor}
              tone="base"
            /> {intl.get("Watch Tutorial")} 
            </InlineStack>
            </Button>
            </Box>
          <div className='sourcing_page_head_button_switch'>
          <Button>
          <InlineStack blockAlign='center'>
          <div className="item" style={{fontSize:'12px',marginRight:5,marginBottom:5}}><img height={20} style={{verticalAlign:'bottom'}} src='/sub/sub_head_light.png' alt='Private product listing'/>{intl.get("Private product listing")}</div>
          <div className="item" style={{lineHeight:0}}>
            <Switch
              onChange={(nextChecked) =>this.handleToggleSwitch(nextChecked)}
              checked={privateProduct === 1}
              width={50}
              height={20}
              onColor='#303030'
              offColor="#DADADA"
              uncheckedIcon={<div className="switchBtn"></div>}
            />
          </div>
          </InlineStack>
            </Button>
          <div className="item icon subscript_section_it_tip">
              <Icon source={QuestionMarkMajor} color="base" />
              <span className="subscript_section_it_tip_txt">{intl.get("When you initiate product sourcing and privatize it from Dropshipman, other users will no longer be able to use the product.")}</span>
          </div>
          </div>
          <div className="item btn">
            <Button
              variant='primary'
              disabled={false}
              onClick={() => this.handleSourcingModal(0, false,0)}
            >
             {intl.get("Sourcing Request")} ({sourcingLimit}/{sourcingDay})
            </Button>
          </div>
          </div>
          </div>}
          </div>
          </Box>
          {this.state.isFirstButtonActive ? <section>
         
          <Layout>
            <Layout.Section>
              <div className='CardContainer'>
                <div className='CardContainerLeft'>
                  <Card>
                    {/* <div className="SourcingBtn">
                      <Button primary={true} onClick={() => { this.handleSourcingModal(0, false) }}>{intl.get("Sourcing")}</Button>
                    </div> */}
                    <Tabs
                      tabs={TabSelectArray}
                      selected={this.state.tabSelected}
                      onSelect={this.handleTabChange}
                    >
                      </Tabs>
                      <Box className="sourcing_filter_title">
                      <Box className='sourcing_filter_select'>
                        <Select
                          options={[
                          { label: intl.get("Product Tittle"), value: 1 },
                          { label: intl.get("Sourcing ID"), value: 2 },]}
                          onChange={this.handleFiltersQueryChanges}
                          value={filterSearch}
                        />
                        </Box>
                        <Box className='sourcing_filter_filter'>
                        <Filters
                          queryValue={this.state.queryValue}
                          queryPlaceholder={intl.get('Search with order ,ID or title')}
                          filters={filters}
                          appliedFilters={appliedFilters}
                          onQueryChange={
                            this.handleFiltersQueryChange.bind(this)
                          }
                          onQueryClear={this.handleQueryValueRemove.bind(this)}
                          onClearAll={this.handleFiltersClearAll}
                        />
                        </Box>
                    </Box>
                        {/* 数据为空显示 */}
                        <div style={{ position: 'relative' }}>

                          {EmptyProductList}

                          <div className="Product__Loading" style={{ display: (isSearching === '1' && ShowCountNumber === 0) ? 'block' : 'none' }}>
                            <div className="Product__Loading_Image">
                              <img style={{ width: '32px', height: '32px', verticalAlign: 'middle' }} src='/loading.gif' alt="loading" />
                            </div>
                          </div>
                        </div>

                         
                      {/* sourcing列表 */}
                      <div style={{ position: 'relative' }}>
                        {SourcingListTable}
                        <div className="Product__Loading" style={{ display: (isSearching === '1' && ShowCountNumber > 0) ? 'block' : 'none' }}>
                          <div className="Product__Loading_Image">
                            <img style={{ width: '32px', height: '32px', verticalAlign: 'middle' }} src='/loading.gif' alt="loading" />
                          </div>
                        </div>
                      </div>
                   
                  </Card>
                </div>

                {/* <div className='CardContainerRight'>
                    <Card>
                      <div className='RightCard'>
                        <div className='RightCardTop'>
                          <img src='/new_tag.png' alt='DropShipMan' className='New_tag'/>
                          <img src='/sourcingSquare.png' alt='dropshipman' style={{width:'48px',height:'48px'}}/>
                          <span style={{fontSize:'1.3em',fontWeight:'600'}}>
                            Sourcing Square
                          </span>
                        </div>
                        <p style={{fontSize:'.9em',fontWeight:'560'}}>
                            See what other merchants are looking for, and you can also find what you're looking for.
                        </p>
                        <div className='HavealookBtn'>
                          <Button primary={true} onClick={this.CallBackToPath}>Have a look</Button>
                        </div>
                      </div>
                    </Card>
                  </div> */}

              </div>

              {/* 分页 */}
              {PaginationSettings}
            </Layout.Section>

            {/* <Layout.Section secondary>
              <div className='Sourcing_Square_Box'>
                <Card>
                  <div className='RightCard'>
                    <div className='RightCardTop'>
                      <img src='/new_tag.png' alt='DropShipMan' className='New_tag' />
                      <img src='/sourcingSquare.png' alt='dropshipman' style={{ width: '48px', height: '48px' }} />
                      <span style={{ fontSize: '1.3em', fontWeight: '600' }}>
                        Sourcing Square
                      </span>
                    </div>
                    <div className='HavealookBtn'>
                      <Button primary={true} onClick={this.CallBackToPath}>Have a look</Button>
                    </div>
                  </div>
                </Card>
              </div>
            </Layout.Section> */}

          </Layout>
          </section> : <section> <ShopifyOrder /> </section>}
        </Page>
      </section>
    )

    // sourcing请求限制弹窗
    // const sourcingLimitTips = (
    //   <Modal
    //     open={sourcingLimitModalShow}
    //     onClose={this.handleSourcingLimitModal}
    //     title={<div className='modalHasIcon'>
    //       <Icon source={AlertMinor} color="critical" />
    //       <span>{intl.get('Reach the sourcing limit')}</span>
    //     </div>}
    //     primaryAction={
    //       {
    //         content: intl.get("ok"),
    //         onAction: this.handleSourcingLimitModal,
    //       }
    //     }
    //   >
    //     <Modal.Section>
    //       <p style={{fontSize: 15}}>{intl.get('Sorry, you have reached the daily sourcing limit of {{count}} times.', sourcingDay)}</p>
    //     </Modal.Section>
    //   </Modal>
    // )

    let CheckGooglePluginMessage
    if(GooglePluginInstall) {
      CheckGooglePluginMessage = <ol className='check_google_plugin_ol'>
        <li>{intl.get("Go to 1688")} <Link onClick={() => this.jumpUrl("https://www.1688.com")} external>https://www.1688.com</Link></li>
        <li>{intl.get("Select the products you want to import to your Shopify store, enter the product details page.")}</li>
        <li>{intl.get("Enable Dropshipman Chrome Extension, then click the \"Add to my store\" button at the bottom right corner of the product details page to add the product.")}</li>
        <li>{intl.get("After the products are successfully added, you can find the corresponding products in the Product List>Dropshipman>Not imported in the Dropshipman APP.")}</li>
      </ol>
    } else {
      CheckGooglePluginMessage = <p style={{fontSize: 16}}>{intl.get("We found that you haven't installed Dropshipman Chrome Extension, which will not facilitate you to sourcing goods from 1688. Do you want to install it?")}</p>
    }

    const CheckGooglePluginModal = (
      <Modal
        open={CheckGooglePluginActive}
        onClose={() => this.handleCheckGooglePluginModal()}
        title={GooglePluginInstall ? intl.get('Sourcing From 1688') : intl.get('Install Dropshipman Chrome Extension')}
        primaryAction={GooglePluginInstall ? {
          content: intl.get("Continue"),
          onAction: () => {this.jumpUrl("https://www.1688.com")},
        } : {
          content: intl.get("Install"),
          onAction: () => {this.jumpUrl("https://chrome.google.com/webstore/detail/dropshipman-aliexpresscom/bobhjedlciclpchpelkgiojkmmfgnihg?")},
        }}
        secondaryActions={!GooglePluginInstall && [{
          content: intl.get("Cancel"),
          onAction: () => this.handleCheckGooglePluginModal()
        }]}
      >
        <Modal.Section>
           
            {CheckGooglePluginMessage}
           
        </Modal.Section>
      </Modal>)
    return (
      <div style={{minHeight:'800px'}}>
        {/* 页面内容 */}
        {pageContent}
        {/* sourcing 弹窗 */}
        {SourcingModalContent}
        {/* SourcingConfirm 弹窗 */}
        <SourcingConfirmModal 
          active={this.state.isOpenSourcingConfirmModal}
          close={()=>this.closeConfirmModal()}
          cancel={()=>this.setState({isOpenSourcingConfirmModal:false})}
          handleStatusEdit={()=>this.handleStatusEdit()}
          sourcingRecord={this.state.sourcingRecord}
        />
        {/* sourcing 限制提示 */}
        {/* {sourcingLimitTips} */}
        <SourcingLimitModal num={this.state.sourcingDay} sourcingOpen={sourcingLimitModalShow} setSourcingOpen={()=>this.setState({sourcingLimitModalShow:false})}/>
        
        {/* 批量操作弹窗 */}
        {BulkOperationTipsModal}
        {/* 谷歌插件检测弹窗 */}
        {CheckGooglePluginModal}
        {/* 升级为会员弹窗 */}
        <UpgradePlanModal upgradeOpen={this.state.upgradeModal} setUpgradeOpen={()=>this.setState({upgradeModal:false})}/>
        {/* 功能视频介绍 */}
        <NoviceSourcingModal upgradeOpen={this.state.noviceModal} setUpgradeOpen={()=>this.setState({noviceModal:false})}/>
        {toastMarkup}
      </div>
    );

    function disambiguateLabel (key, value) {
      switch (key) {
        case 'taggedWith':
          return `Tagged with ${value}`;
        default:
          return value;
      }
    }

    function isEmpty (value) {
      if (Array.isArray(value)) {
        return value.length === 0;
      } else {
        return value === '' || value == null;
      }
    }

  }
}

export default withRouter(SourcingClass);
